import * as React from "react";
const SvgCatalog = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M3.49964 4.89951C3.99669 4.89951 4.39964 4.49657 4.39964 3.99951C4.39964 3.50246 3.99669 3.09951 3.49964 3.09951C3.00258 3.09951 2.59964 3.50246 2.59964 3.99951C2.59964 4.49657 3.00258 4.89951 3.49964 4.89951Z",
	fill: "#8D969F"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M6.23404 3.24961C5.81983 3.24961 5.48404 3.5854 5.48404 3.99961C5.48404 4.41382 5.81983 4.74961 6.23404 4.74961H12.2458C12.6601 4.74961 12.9958 4.41382 12.9958 3.99961C12.9958 3.5854 12.6601 3.24961 12.2458 3.24961H6.23404Z",
	fill: "#8D969F"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M6.24097 12.7496L12.2498 12.7496C12.664 12.7496 12.9998 12.4138 12.9998 11.9996C12.9998 11.5854 12.664 11.2496 12.2498 11.2496L6.24097 11.2496C5.82676 11.2496 5.49097 11.5854 5.49097 11.9996C5.49097 12.4138 5.82676 12.7496 6.24097 12.7496Z",
	fill: "#8D969F"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M5.00757 7.99961C5.00757 7.5854 5.34336 7.24961 5.75757 7.24961H13.2536C13.6678 7.24961 14.0036 7.5854 14.0036 7.99961C14.0036 8.41382 13.6678 8.74961 13.2536 8.74961H5.75757C5.34336 8.74961 5.00757 8.41382 5.00757 7.99961Z",
	fill: "#8D969F"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M2.99961 8.89961C3.49667 8.89961 3.89961 8.49667 3.89961 7.99961C3.89961 7.50255 3.49667 7.09961 2.99961 7.09961C2.50255 7.09961 2.09961 7.50255 2.09961 7.99961C2.09961 8.49667 2.50255 8.89961 2.99961 8.89961Z",
	fill: "#8D969F"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M4.39973 12C4.39973 12.497 3.99678 12.9 3.49973 12.9C3.00267 12.9 2.59973 12.497 2.59973 12C2.59973 11.5029 3.00267 11.1 3.49973 11.1C3.99678 11.1 4.39973 11.5029 4.39973 12Z",
	fill: "#8D969F"
}));
export default SvgCatalog;
